import { Button, Card, Dropdown, Form, Layout, Menu, PageHeader, Select, Table, Typography } from 'antd';
import { Column } from '@ant-design/charts';
import { useEffect, useRef, useState } from 'react';
import { apiClient, apiErrorMessage } from '../../utils';
import { DownOutlined } from '@ant-design/icons';
import { useReactToPrint } from 'react-to-print';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

export function Report1Page() {
  const { Text } = Typography;
  const { Content } = Layout;
  const { Option } = Select;

  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [filterGrids, setFilterGrids] = useState<any[]>();
  const [allTableData, setAllTableData] = useState<any>([]);
  const [allExcelData, setAllExcelData] = useState<any>([]);
  const [filteredTableData, setFilteredTableData] = useState<any>([]);
  const [filteredExcelData, setFilteredExcelData] = useState<any>([]);
  const [chart, setChart] = useState<any>();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    // setLoading(true);
    // apiClient
    //   .get('grid-records/report1')
    //   .then(response => {
    //     const responseData = response.data;
    //     setAllData(responseData);
    //     setFilteredData(responseData);

    //     const grids = responseData.filter((m: any) => m.status === 'Tamamlanmış').map((m: any) => m.grid);
    //     setFilterGrids(grids);
    //     const responseTableData = grids.map((g: string) => {
    //       const completed = responseData.find((m: any) => m.grid === g && m.status === 'Tamamlanmış')?.count || 0;
    //       const pending = responseData.find((m: any) => m.grid === g && m.status === 'Bekleyen')?.count || 0;
    //       return {
    //         grid: g,
    //         completed,
    //         pending,
    //         total: completed + pending,
    //       };
    //     });
    //     const responseExcelData = grids.map((g: string) => {
    //       const completed = responseData.find((m: any) => m.grid === g && m.status === 'Tamamlanmış')?.count || 0;
    //       const pending = responseData.find((m: any) => m.grid === g && m.status === 'Bekleyen')?.count || 0;
    //       return {
    //         Tablo: g,
    //         Tamamlanmış: completed,
    //         Bekleyen: pending,
    //         Toplam: completed + pending,
    //       };
    //     });

    //     setAllTableData(responseTableData);
    //     setAllExcelData(responseExcelData);
    //     setFilteredTableData(responseTableData);
    //     setFilteredExcelData(responseExcelData);
    //   })
    //   .catch((reason: any) => {
    //     apiErrorMessage(reason);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });
  };

  const config = {
    data: filteredData,
    xField: 'grid',
    yField: 'count',
    seriesField: 'status',
    isStack: true,
  };

  const componentRef = useRef(null);

  const print = useReactToPrint({
    content: () => componentRef.current,
  });

  const exportToExcel = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(filteredExcelData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, 'rapor' + fileExtension);
  };

  const exportToImage = () => {
    chart?.downloadImage();
  };

  const onReportActionClick = (e: any) => {
    if (e.key === 'print') {
      if (print) print();
    } else if (e.key === 'exportToExcel') {
      exportToExcel();
    } else if (e.key === 'exportToImage') {
      exportToImage();
    }
  };

  const tableColumns = [
    {
      title: 'Tablo',
      dataIndex: 'grid',
      key: 'grid',
    },
    {
      title: 'Tamamlanmış',
      dataIndex: 'completed',
      key: 'completed',
      render: (count: number) => (count === 0 ? '-' : count),
    },
    {
      title: 'Bekleyen',
      dataIndex: 'pending',
      key: 'pending',
      render: (count: number) => (count === 0 ? '-' : count),
    },
    {
      title: 'Toplam',
      dataIndex: 'total',
      key: 'total',
      render: (count: number) => (count === 0 ? '-' : count),
    },
  ];

  const reportActions = () => (
    <Menu onClick={(e: any) => onReportActionClick(e)}>
      <Menu.Item key="print">
        <Text>Yazdır</Text>
      </Menu.Item>
      <Menu.Item key="exportToExcel">
        <Text>Tabloyu Excel olarak indir</Text>
      </Menu.Item>
      <Menu.Item key="exportToImage">
        <Text>Grafiği resim olarak indir</Text>
      </Menu.Item>
    </Menu>
  );

  const onFilterChange = (filteredGrid: string) => {
    const data = allData.filter((m: any) => m.grid === filteredGrid);
    setFilteredData(data);
    const tableData = allTableData.filter((m: any) => m.grid === filteredGrid);
    setFilteredTableData(tableData);
    const excelData = allExcelData.filter((m: any) => m.Table === filteredGrid);
    setFilteredExcelData(excelData);
  };

  return (
    <>
      <PageHeader
        onBack={() => window.history.back()}
        title="Bölüm - risk bildirimi raporu"
        subTitle="Her bölüm için bildirilen risk sayıları raporu"
        extra={
          <Dropdown overlay={reportActions()} trigger={['click']}>
            <Button>
              Dışa aktar <DownOutlined />
            </Button>
          </Dropdown>
        }
      />

      <Card style={{ margin: '2rem' }}>
        <Form layout="inline">
          <Form.Item name="taskType">
            <Select allowClear placeholder="Tablo" style={{ width: '12rem' }} onChange={onFilterChange}>
              {filterGrids?.map(g => (
                <Option key={g} value={g}>
                  {g}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Card>

      <div ref={componentRef}>
        <Content style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
          <Column loading={loading} {...config} onReady={chartInstance => setChart(chartInstance)} />
          <Table
            columns={tableColumns}
            rowKey={row => row.grid}
            dataSource={filteredTableData}
            loading={loading}
            pagination={false}
            style={{ marginTop: '4rem' }}
          />
        </Content>
      </div>
    </>
  );
}
